import Image from "next/image";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { memo } from "react";
import ArrowLink from "@/components/ui/arrow-link";
import { Typography } from "@/components/ui/typography";
import Icon, { IconIdType } from "@/components/ui/Icon";

export type SolutionsCardProps = {
  iconId?: IconIdType;
  title: string;
  description: string;
  href?: string;
  linkLabel?: string;
} & React.ComponentProps<"div">;

const SolutionsCard = ({
  iconId,
  title,
  description,
  href = "#",
  linkLabel,
  className,
}: SolutionsCardProps) => {
  return (
    <div
      className={cn(
        "flex flex-col border bg-white border-neutral-200 rounded-3xl overflow-hidden lg:rounded-2xl lg:border-0",

        className
      )}
    >
      <div className="flex flex-col p-5 flex-auto min-w-0">
        {!!iconId && (
          <Icon
            id={iconId}
            width={32}
            height={32}
            className="w-12 h-12 shrink-0 md:w-8 md:h-8 text-blue-500"
          />
        )}
        <div
          className={cn("grid grid-cols-1 gap-3 md:gap-2", {
            "mt-3": !!iconId,
          })}
        >
          <Typography
            variant="titleMd"
            className="text-semantic-text-primary font-semibold lg:leading-[150%] lg:text-gray-800"
          >
            <h4>{title}</h4>
          </Typography>
          <div className="text-semantic-text-secondary text-base leading-[160%] lg:text-sm lg:leading-[150%] lg:text-gray-600">
            <p>{description}</p>
          </div>
        </div>
        <div className="mt-auto pt-[23] pb-[11] sm:pt-3 sm:pb-0 flex">
          <ArrowLink href={href}>{linkLabel}</ArrowLink>
        </div>
      </div>
    </div>
  );
};
export default memo(SolutionsCard);
